import {
  MOSTRAR_CRITERIOS,
  MOSTRAR_CRITERIO,
  LOADING_CRITERIO,
  CRITERIO_FAILED,
} from "../types";

import { api_basev2 } from "../../config";
import { getData } from "../../utils/api-client";

export const getCriterios = () => async (dispatch) => {
  let urlv2 = api_basev2 + "Criterios/ObtenerCriterios/";

  dispatch({ type: LOADING_CRITERIO });
  return await getData
    .get(urlv2)
    .then((resultado) => {
      dispatch({ type: MOSTRAR_CRITERIOS, payload: resultado.data.data});
      return resultado.data.data;
    })
    .catch((error) => {
      if (error) {
        dispatch({ type: CRITERIO_FAILED });
      }
      return [];
    });
};
